import { useEffect, useState } from "react";
import { Markdown } from "@/components/ui/markdown";
import { Seo } from "@/components/Seo";
import type { Page } from "@/lib/types";

export function PrivacyPage() {
  const [page, setPage] = useState<Page | null>(null);

  useEffect(() => {
    fetch("/api/pages/privacy").then((r) => r.json()).then(setPage);
  }, []);

  if (!page) {
    return (
      <div className="container mx-auto px-6 py-16 text-center">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-6 py-16 max-w-3xl">
      <Seo
        title="Privacy Policy"
        description="Privacy policy for Loose Goose Systems — what we collect, how we use it, and how we keep it minimal (no analytics or tracking)."
        path="/privacy"
      />
      <h1 className="font-display text-4xl font-extrabold tracking-tight mb-8">{page.title}</h1>
      <Markdown source={page.content} />
    </div>
  );
}
